import { Asset } from '../asset';
import { AssetFileType } from '../asset-file-type.enum';
import { MockupAsset } from '@api-ui-app/src/app/mockup-studio/types/mockup-studio-assets';

export const getAssetFileUrl = (asset: Asset | MockupAsset, assetFileType: AssetFileType): string => {
  if (!asset || !asset.files || !assetFileType) {
    return null;
  }

  return asset.files.find(file => file.type === assetFileType)?.url ?? null;
};
